import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelDynamic as _vModelDynamic, vShow as _vShow } from "vue"
import _imports_0 from '@/assets/icons/del-selected-file.svg'
import _imports_1 from '@/assets/icons/chevron-right-gray.svg'


const _hoisted_1 = {
  key: 0,
  class: "input-row"
}
const _hoisted_2 = { class: "input-wr" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "section-title" }
const _hoisted_5 = {
  key: 1,
  class: "section-title-second"
}
const _hoisted_6 = {
  key: 2,
  class: "info-message-row"
}
const _hoisted_7 = {
  key: 3,
  class: "company-details"
}
const _hoisted_8 = {
  key: 0,
  class: "input-row"
}
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 1,
  class: "input-row"
}
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = {
  key: 2,
  class: "input-row"
}
const _hoisted_13 = { class: "input-wr" }
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = {
  key: 0,
  class: "input-wr w-50"
}
const _hoisted_16 = {
  key: 1,
  class: "input-wr w-25"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 2,
  class: "input-wr w-25"
}
const _hoisted_19 = {
  key: 4,
  class: "section-title"
}
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = { class: "input-wr" }
const _hoisted_22 = { class: "input-row" }
const _hoisted_23 = { class: "input-wr" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "tips middle-name-toggle" }
const _hoisted_26 = { class: "input-row" }
const _hoisted_27 = { class: "input-wr" }
const _hoisted_28 = { class: "input-row" }
const _hoisted_29 = { class: "input-wr w-60" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "input-wr w-40" }
const _hoisted_32 = { class: "input-row" }
const _hoisted_33 = { class: "input-wr" }
const _hoisted_34 = { class: "input-row" }
const _hoisted_35 = {
  key: 0,
  class: "input-wr w-50"
}
const _hoisted_36 = {
  key: 1,
  class: "input-wr w-25"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 2,
  class: "input-wr w-25"
}
const _hoisted_39 = {
  key: 5,
  class: "input-row"
}
const _hoisted_40 = { class: "input-wr" }
const _hoisted_41 = {
  key: 6,
  class: "input-row"
}
const _hoisted_42 = { class: "input-wr" }
const _hoisted_43 = {
  key: 0,
  class: "select-file-name"
}
const _hoisted_44 = { class: "document-name" }
const _hoisted_45 = {
  key: 2,
  class: "spinner spinner-small"
}
const _hoisted_46 = {
  key: 0,
  class: "section-title-second"
}
const _hoisted_47 = {
  key: 1,
  class: "input-row"
}
const _hoisted_48 = { class: "input-wr" }
const _hoisted_49 = {
  key: 2,
  class: "input-row"
}
const _hoisted_50 = { class: "input-wr" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "tips middle-name-toggle" }
const _hoisted_53 = {
  key: 3,
  class: "input-row"
}
const _hoisted_54 = { class: "input-wr" }
const _hoisted_55 = { class: "input-row" }
const _hoisted_56 = {
  key: 0,
  class: "input-wr w-60"
}
const _hoisted_57 = {
  key: 1,
  class: "input-wr w-40"
}
const _hoisted_58 = { class: "input-row" }
const _hoisted_59 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_60 = { class: "input-row" }
const _hoisted_61 = {
  key: 0,
  class: "input-wr w-50"
}
const _hoisted_62 = {
  key: 1,
  class: "input-wr w-25"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 2,
  class: "input-wr w-25"
}
const _hoisted_65 = {
  key: 4,
  class: "input-row"
}
const _hoisted_66 = { class: "input-wr" }
const _hoisted_67 = {
  key: 5,
  class: "input-row"
}
const _hoisted_68 = { class: "input-wr" }
const _hoisted_69 = {
  key: 0,
  class: "select-file-name"
}
const _hoisted_70 = { class: "document-name" }
const _hoisted_71 = {
  key: 2,
  class: "spinner spinner-small"
}
const _hoisted_72 = {
  key: 8,
  class: "input-row"
}
const _hoisted_73 = { class: "input-wr" }
const _hoisted_74 = {
  key: 9,
  class: "input-row"
}
const _hoisted_75 = { class: "input-wr" }
const _hoisted_76 = {
  key: 10,
  class: "aml-section"
}
const _hoisted_77 = {
  key: 0,
  class: "section-title-second"
}
const _hoisted_78 = { class: "input-row" }
const _hoisted_79 = { class: "label" }
const _hoisted_80 = {
  key: 0,
  class: "required-field"
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = ["value", "placeholder", "onInput", "onBlur"]
const _hoisted_83 = ["onUpdate:modelValue", "type", "min", "maxlength", "placeholder", "onBlur"]
const _hoisted_84 = {
  key: 3,
  class: "tips"
}
const _hoisted_85 = { class: "input-wr" }
const _hoisted_86 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_87 = { class: "input-row" }
const _hoisted_88 = { class: "label" }
const _hoisted_89 = {
  key: 0,
  class: "required-field"
}
const _hoisted_90 = ["onClick"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onUpdate:modelValue", "type", "maxlength", "placeholder", "onBlur"]
const _hoisted_94 = {
  key: 2,
  class: "tips"
}
const _hoisted_95 = { class: "input-wr" }
const _hoisted_96 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_97 = {
  key: 11,
  class: "section-title solicitor-title"
}
const _hoisted_98 = { class: "input-row" }
const _hoisted_99 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_100 = ["disabled"]
const _hoisted_101 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_102 = ["disabled"]
const _hoisted_103 = {
  key: 13,
  class: "input-row"
}
const _hoisted_104 = { class: "input-wr" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { class: "input-row" }
const _hoisted_107 = {
  key: 0,
  class: "input-wr w-50"
}
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 1,
  class: "input-wr w-25"
}
const _hoisted_110 = ["disabled"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = {
  key: 2,
  class: "input-wr w-25"
}
const _hoisted_113 = ["disabled"]
const _hoisted_114 = { class: "input-row" }
const _hoisted_115 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_116 = ["disabled"]
const _hoisted_117 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_118 = {
  key: 14,
  class: "section-title"
}
const _hoisted_119 = {
  key: 15,
  class: "input-row"
}
const _hoisted_120 = { class: "input-wr" }
const _hoisted_121 = { class: "input dropdown-input" }
const _hoisted_122 = {
  key: 16,
  class: "section-title"
}
const _hoisted_123 = { class: "input-row" }
const _hoisted_124 = { class: "input-wr" }
const _hoisted_125 = { class: "input-wr" }
const _hoisted_126 = { class: "input-row" }
const _hoisted_127 = { class: "input-wr" }
const _hoisted_128 = { class: "input-wr" }
const _hoisted_129 = {
  key: 17,
  class: "input-row"
}
const _hoisted_130 = { class: "input-wr" }
const _hoisted_131 = {
  key: 18,
  class: "input-row"
}
const _hoisted_132 = { class: "input-wr" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = {
  key: 19,
  class: "input-row"
}
const _hoisted_135 = { class: "input-wr" }
const _hoisted_136 = {
  key: 0,
  class: "select-file-name"
}
const _hoisted_137 = { class: "document-name" }
const _hoisted_138 = {
  key: 2,
  class: "spinner spinner-small"
}
const _hoisted_139 = {
  key: 20,
  class: "input-row"
}
const _hoisted_140 = { class: "input-wr" }
const _hoisted_141 = { class: "input dropdown-input" }
const _hoisted_142 = {
  key: 21,
  class: "input-row"
}
const _hoisted_143 = { class: "input-wr" }
const _hoisted_144 = { class: "input dropdown-input" }
const _hoisted_145 = { class: "input-wr" }
const _hoisted_146 = ["disabled"]
const _hoisted_147 = { class: "agree" }
const _hoisted_148 = ["disabled"]
const _hoisted_149 = {
  key: 23,
  class: "spiner-wr"
}
const _hoisted_150 = {
  key: 1,
  class: "spinner"
}
const _hoisted_151 = {
  key: 2,
  class: "card-box"
}
const _hoisted_152 = { class: "sticky" }
const _hoisted_153 = { class: "save-draft-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.estate._id && !$setup.formLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["form-box", { 'preview-form-box': $setup.props.isPreview }])
        }, [
          (!$props.isPreview)
            ? (_openBlock(), _createBlock($setup["EOIInfoMessage"], {
                key: 0,
                "is-refundable": $setup.estate.isRefundable,
                deposit: $setup.estate?.initDeposit,
                isZeroDeposit: $setup.isZeroDeposit,
                customTerms: $setup.estate?.customTerms,
                isEmailBelongsToCustomer: $setup.isEmailBelongsToCustomer,
                hasInitialHoldEmailError: $setup.hasInitialHoldEmailError
              }, null, 8, ["is-refundable", "deposit", "isZeroDeposit", "customTerms", "isEmailBelongsToCustomer", "hasInitialHoldEmailError"]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: _normalizeClass(["eoi-form", { 'preview-eoi-form': $setup.props.isPreview }]),
            onSubmit: _cache[90] || (_cache[90] = _withModifiers(() => {}, ["prevent"]))
          }, [
            ($setup.requestAmlInformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _cache[92] || (_cache[92] = _createElementVNode("label", { class: "label" }, [
                      _createTextVNode("Purchaser Type"),
                      _createElementVNode("span", { class: "required-field" }, "*")
                    ], -1)),
                    _cache[93] || (_cache[93] = _createElementVNode("span", { class: "tips" }, "Select the type of entity purchasing this lot.", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", { error: $setup.purchaserTypeError, 'not-selected': !$setup.requestForm.purchaserType }])
                        }, _toDisplayString($setup.requestForm.purchaserType || "Select purchaser type"), 3)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.purchaserTypes, (type) => {
                            return _createElementVNode("li", {
                              key: type,
                              onClick: ($event: any) => ($setup.setPurchaserType(type))
                            }, _toDisplayString(type), 9, _hoisted_3)
                          }), 64))
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.purchaserTypeError }])
                    }, _toDisplayString($setup.purchaserTypeError ? "Purchaser type is required" : ""), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.isPurchasingByCompany ? "Company details" : "Buyer details"), 1),
            ($setup.isSecondBuyer)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Buyer 1"))
              : _createCommentVNode("", true),
            ($setup.hasActiveFields($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode($setup["InfoMessage"], { message: `Information submitted on this form will be used to generate a contract for your purchase. Please ensure all information and spelling matches your I.D.` })
                ]))
              : _createCommentVNode("", true),
            ($setup.isPurchasingByCompany && $setup.hasActiveFields($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.NAME))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[94] || (_cache[94] = _createElementVNode("label", { class: "label" }, "Name", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.requestForm.companyDetails.name) = $event)),
                            type: "text",
                            placeholder: "Company Name",
                            class: _normalizeClass({ error: $setup.v$.companyDetails.name.$error }),
                            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.companyDetails.name.$touch && $setup.v$.companyDetails.name.$touch(...args)))
                          }, null, 34), [
                            [
                              _vModelText,
                              $setup.requestForm.companyDetails.name,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.name.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.name.$errors[0]?.$message), 3)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.ABN_ACN))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[95] || (_cache[95] = _createElementVNode("label", { class: "label" }, "ABN / ACN", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.requestForm.companyDetails.businessIdentifier) = $event)),
                            placeholder: "0123456789",
                            class: _normalizeClass({ error: $setup.v$.companyDetails.businessIdentifier.$error }),
                            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.v$.companyDetails.businessIdentifier.$touch && $setup.v$.companyDetails.businessIdentifier.$touch(...args)))
                          }, null, 34), [
                            [
                              _vModelText,
                              $setup.requestForm.companyDetails.businessIdentifier,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.businessIdentifier.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.businessIdentifier.$errors[0]?.$message), 3)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.REGISTERED_ADDRESS))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _cache[96] || (_cache[96] = _createElementVNode("label", { class: "label" }, "Registered Address", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.requestForm.companyDetails.address) = $event)),
                            placeholder: "Registered Address",
                            class: _normalizeClass({ error: $setup.v$.companyDetails.address.$error }),
                            onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.v$.companyDetails.address.$touch && $setup.v$.companyDetails.address.$touch(...args)))
                          }, null, 34), [
                            [
                              _vModelText,
                              $setup.requestForm.companyDetails.address,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.address.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.address.$errors[0]?.$message), 3)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.SUBURB))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[97] || (_cache[97] = _createElementVNode("label", { class: "label" }, "Suburb", -1)),
                          _withDirectives(_createElementVNode("input", {
                            placeholder: "Suburb",
                            type: "text",
                            class: _normalizeClass({ error: $setup.v$.companyDetails.suburb.$error }),
                            onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.v$.companyDetails.suburb.$touch && $setup.v$.companyDetails.suburb.$touch(...args))),
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.requestForm.companyDetails.suburb) = $event))
                          }, null, 34), [
                            [_vModelText, $setup.requestForm.companyDetails.suburb]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.suburb.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.suburb.$errors[0]?.$message), 3)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.STATE))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _cache[98] || (_cache[98] = _createElementVNode("label", { class: "label" }, "State", -1)),
                          _createVNode($setup["DropDown"], null, {
                            control: _withCtx(() => [
                              _createElementVNode("button", {
                                class: _normalizeClass(["input dropdown-input", { error: $setup.v$.companyDetails.state.$error, 'not-selected': !$setup.requestForm.companyDetails.state }])
                              }, _toDisplayString($setup.requestForm.companyDetails.state || "Select"), 3)
                            ]),
                            dropdown: _withCtx(() => [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: state,
                                    onClick: ($event: any) => ($setup.requestForm.companyDetails.state = state)
                                  }, _toDisplayString(state), 9, _hoisted_17))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.state.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.state.$errors[0]?.$message), 3)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.getTemplateField($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS, $setup.EoiTemplateFields.POSTCODE))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[99] || (_cache[99] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.requestForm.companyDetails.postcode) = $event)),
                            class: _normalizeClass({ error: $setup.v$.companyDetails.postcode.$error }),
                            type: "text",
                            maxlength: "4",
                            placeholder: "e.g. 2000",
                            onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.v$.companyDetails.postcode.$touch && $setup.v$.companyDetails.postcode.$touch(...args)))
                          }, null, 34), [
                            [_vModelText, $setup.requestForm.companyDetails.postcode]
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.companyDetails.postcode.$error }])
                          }, _toDisplayString($setup.v$.companyDetails.postcode.$errors[0]?.$message), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.isPurchasingByCompany && $setup.hasActiveFields($setup.EoiTemplateGroups.PURCHASE_AS_COMPANY_DETAILS))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Contact Person details"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[100] || (_cache[100] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.firstName) = $event)),
                  type: "text",
                  placeholder: "First Name",
                  class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.firstName.$error }),
                  onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.firstName.$touch && $setup.v$.buyersData.firstBuyer.firstName.$touch(...args)))
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.requestForm.buyersData.firstBuyer.firstName,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _cache[101] || (_cache[101] = _createElementVNode("span", { class: "tips" }, "Make sure it matches the name on your ID", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.firstName.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.firstName.$errors[0]?.$message), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[102] || (_cache[102] = _createElementVNode("label", { class: "label" }, "Middle Name(s)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.middleName) = $event)),
                  type: "text",
                  disabled: !$setup.hasFirstBuyerMiddleName,
                  class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.middleName.$error }),
                  onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.middleName.$touch && $setup.v$.buyersData.firstBuyer.middleName.$touch(...args))),
                  placeholder: "Middle Name(s)"
                }, null, 42, _hoisted_24), [
                  [
                    _vModelText,
                    $setup.requestForm.buyersData.firstBuyer.middleName,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode($setup["CheckboxInput"], {
                    modelValue: !$setup.hasFirstBuyerMiddleName,
                    label: 'I do not have a middle name',
                    onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ($setup.onToggleFirstBuyerMiddleName(!$event)))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.middleName.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.middleName.$errors[0]?.$message), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[103] || (_cache[103] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.lastName) = $event)),
                  type: "text",
                  placeholder: "Last Name",
                  class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.lastName.$error }),
                  onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.lastName.$touch && $setup.v$.buyersData.firstBuyer.lastName.$touch(...args)))
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.requestForm.buyersData.firstBuyer.lastName,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _cache[104] || (_cache[104] = _createElementVNode("span", { class: "tips" }, "Make sure it matches the name on your ID", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.lastName.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.lastName.$errors[0]?.$message), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[105] || (_cache[105] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.email) = $event)),
                  type: "email",
                  placeholder: "john.smith@gmail.com",
                  class: _normalizeClass($setup.getFirstBuyerEmailClass()),
                  onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.email.$touch && $setup.v$.buyersData.firstBuyer.email.$touch(...args))),
                  disabled: $setup.isLogged() && $setup.isCustomer
                }, null, 42, _hoisted_30), [
                  [
                    _vModelText,
                    $setup.requestForm.buyersData.firstBuyer.email,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.email.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.email.$errors[0]?.$message), 3)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[106] || (_cache[106] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                _createVNode($setup["Cleave"], {
                  modelValue: $setup.requestForm.buyersData.firstBuyer.phone,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.phone) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "0412 345 678",
                  options: $setup.phoneNumberOption($setup.requestForm.buyersData.firstBuyer.phone),
                  class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.phone.$error }),
                  onBlur: $setup.v$.buyersData.firstBuyer.phone.$touch
                }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.phone.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.phone.$errors[0]?.$message), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[107] || (_cache[107] = _createElementVNode("label", { class: "label" }, "Street Address", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.address) = $event)),
                  type: "text",
                  placeholder: "Address",
                  class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.address.$error }),
                  onBlur: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.address.$touch && $setup.v$.buyersData.firstBuyer.address.$touch(...args)))
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.requestForm.buyersData.firstBuyer.address,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.address.$error }])
                }, _toDisplayString($setup.v$.buyersData.firstBuyer.address.$errors[0]?.$message), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              ($setup.getTemplateField('Buyer details', 'Suburb'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "label" }, "Suburb", -1)),
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "Suburb",
                      type: "text",
                      class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.suburb.$error }),
                      onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.suburb.$touch && $setup.v$.buyersData.firstBuyer.suburb.$touch(...args))),
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.suburb) = $event))
                    }, null, 34), [
                      [_vModelText, $setup.requestForm.buyersData.firstBuyer.suburb]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.suburb.$error }])
                    }, _toDisplayString($setup.v$.buyersData.firstBuyer.suburb.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer details', 'State'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "label" }, "State", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", { error: $setup.v$.buyersData.firstBuyer.state.$error, 'not-selected': !$setup.requestForm.buyersData.firstBuyer.state }])
                        }, _toDisplayString($setup.requestForm.buyersData.firstBuyer.state || "Select"), 3)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: state,
                              onClick: ($event: any) => ($setup.requestForm.buyersData.firstBuyer.state = state)
                            }, _toDisplayString(state), 9, _hoisted_37))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.state.$error }])
                    }, _toDisplayString($setup.v$.buyersData.firstBuyer.state.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer details', 'Postcode'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _cache[110] || (_cache[110] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.requestForm.buyersData.firstBuyer.postcode) = $event)),
                      class: _normalizeClass({ error: $setup.v$.buyersData.firstBuyer.postcode.$error }),
                      type: "text",
                      maxlength: "4",
                      placeholder: "e.g. 2000",
                      onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.firstBuyer.postcode.$touch && $setup.v$.buyersData.firstBuyer.postcode.$touch(...args)))
                    }, null, 34), [
                      [_vModelText, $setup.requestForm.buyersData.firstBuyer.postcode]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.postcode.$error }])
                    }, _toDisplayString($setup.v$.buyersData.firstBuyer.postcode.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true)
            ]),
            ($setup.getTemplateField('Buyer details', 'Upload ID (Drivers license, Passport)'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[111] || (_cache[111] = _createElementVNode("label", { class: "label" }, "ID Type", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", { error: $setup.v$.buyersData.firstBuyer.documents[0].documentType.$error }])
                        }, _toDisplayString($setup.requestForm.buyersData.firstBuyer.documents[0]?.documentType), 3)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.setBuyerIdType('firstBuyer', 'Drivers license')))
                          }, "Drivers license"),
                          _createElementVNode("li", {
                            onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.setBuyerIdType('firstBuyer', 'Passport')))
                          }, "Passport")
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[112] || (_cache[112] = _createElementVNode("div", { class: "error-box" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.showFirstBuyerDocument())
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[113] || (_cache[113] = _createElementVNode("label", { class: "label" }, "Document", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["select-file-wrapper", $setup.getFirstBuyerDocumentClass()])
                    }, [
                      ($setup.showFirstBuyerDocumentName())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString($setup.requestForm.buyersData.firstBuyer.documents[0].name), 1),
                            _createElementVNode("img", {
                              class: "document-name-close",
                              src: _imports_0,
                              onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.deleteDocument('firstBuyer')))
                            })
                          ]))
                        : (!$setup.isFileLoading)
                          ? (_openBlock(), _createBlock($setup["InputFile"], {
                              key: 1,
                              onChange: $setup.uploadFile,
                              text: "Upload file",
                              viewClass: "",
                              accept: $setup.acceptedTypes,
                              owner: "firstBuyer"
                            }, null, 8, ["accept"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_45))
                    ], 2),
                    _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.documentPrivacyTip)),
                    _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.imageUploadTips)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.firstBuyer.documents[0].link.$error || $setup.fileInfo.firstBuyer.isError }])
                    }, _toDisplayString($setup.v$.buyersData.firstBuyer.documents[0].name.$errors[0]?.$message || $setup.fileInfo.firstBuyer.errorMessage), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.hasActiveFields('Buyer 2 details'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 7,
                  class: _normalizeClass(["button add-buyer", { hide: $setup.isSecondBuyer }]),
                  onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.isSecondBuyer = true))
                }, _toDisplayString($setup.isPurchasingByCompany ? "Add Contact Person" : "Add Buyer"), 3))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["second-buyer", { hide: !$setup.isSecondBuyer }])
            }, [
              ($setup.hasActiveFields('Buyer 2 details'))
                ? (_openBlock(), _createElementBlock("h1", _hoisted_46, _toDisplayString($setup.isPurchasingByCompany ? "Contact Person 2 details" : "Buyer 2 details"), 1))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer 2 details', 'First Name'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[114] || (_cache[114] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.firstName) = $event)),
                        type: "text",
                        placeholder: "First Name",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.firstName.$error }),
                        onBlur: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.firstName.$touch && $setup.v$.buyersData.secondBuyer.firstName.$touch(...args)))
                      }, null, 34), [
                        [
                          _vModelText,
                          $setup.requestForm.buyersData.secondBuyer.firstName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.firstName.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.firstName.$errors[0]?.$message), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer 2 details', 'Middle Name(s)'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[115] || (_cache[115] = _createElementVNode("label", { class: "label" }, "Middle Name(s)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.middleName) = $event)),
                        onBlur: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.middleName.$touch && $setup.v$.buyersData.secondBuyer.middleName.$touch(...args))),
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.middleName.$error }),
                        disabled: !$setup.hasSecondBuyerMiddleName,
                        type: "text",
                        placeholder: "Middle Name(s)"
                      }, null, 42, _hoisted_51), [
                        [
                          _vModelText,
                          $setup.requestForm.buyersData.secondBuyer.middleName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode($setup["CheckboxInput"], {
                          modelValue: !$setup.hasSecondBuyerMiddleName,
                          label: 'I do not have a middle name',
                          onClick: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"])),
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ($setup.onToggleSecondBuyerMiddleName(!$event)))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.middleName.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.middleName.$errors[0]?.$message), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer 2 details', 'Last Name'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[116] || (_cache[116] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.lastName) = $event)),
                        type: "text",
                        placeholder: "Last Name",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.lastName.$error }),
                        onBlur: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.lastName.$touch && $setup.v$.buyersData.secondBuyer.lastName.$touch(...args)))
                      }, null, 34), [
                        [
                          _vModelText,
                          $setup.requestForm.buyersData.secondBuyer.lastName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.lastName.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.lastName.$errors[0]?.$message), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_55, [
                ($setup.getTemplateField('Buyer 2 details', 'Email'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _cache[117] || (_cache[117] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.email) = $event)),
                        type: "email",
                        placeholder: "john.smith@gmail.com",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.email.$error }),
                        onBlur: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.email.$touch && $setup.v$.buyersData.secondBuyer.email.$touch(...args)))
                      }, null, 34), [
                        [
                          _vModelText,
                          $setup.requestForm.buyersData.secondBuyer.email,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.email.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.email.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.getTemplateField('Buyer 2 details', 'Phone Number'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _cache[118] || (_cache[118] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                      _createVNode($setup["Cleave"], {
                        modelValue: $setup.requestForm.buyersData.secondBuyer.phone,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.phone) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: "0412 345 678",
                        options: $setup.phoneNumberOption($setup.requestForm.buyersData.secondBuyer.phone),
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.phone.$error }),
                        onBlur: $setup.v$.buyersData.secondBuyer.phone.$touch
                      }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.phone.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.phone.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_58, [
                ($setup.getTemplateField('Buyer 2 details', 'Address'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _cache[119] || (_cache[119] = _createElementVNode("label", { class: "label" }, "Address", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.address) = $event)),
                        type: "text",
                        placeholder: "Address",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.address.$error }),
                        onBlur: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.address.$touch && $setup.v$.buyersData.secondBuyer.address.$touch(...args)))
                      }, null, 34), [
                        [
                          _vModelText,
                          $setup.requestForm.buyersData.secondBuyer.address,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.address.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.address.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                ($setup.getTemplateField('Buyer 2 details', 'Suburb'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _cache[120] || (_cache[120] = _createElementVNode("label", { class: "label" }, "Suburb", -1)),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Suburb",
                        type: "text",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.suburb?.$error }),
                        onBlur: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.suburb.$touch && $setup.v$.buyersData.secondBuyer.suburb.$touch(...args))),
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.suburb) = $event))
                      }, null, 34), [
                        [_vModelText, $setup.requestForm.buyersData.secondBuyer.suburb]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.suburb.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.suburb.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.getTemplateField('Buyer 2 details', 'State'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _cache[121] || (_cache[121] = _createElementVNode("label", { class: "label" }, "State", -1)),
                      _createVNode($setup["DropDown"], null, {
                        control: _withCtx(() => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["input dropdown-input", { error: $setup.v$.buyersData.secondBuyer.state?.$error, 'not-selected': !$setup.requestForm.buyersData.secondBuyer.state }])
                          }, _toDisplayString($setup.requestForm.buyersData.secondBuyer.state || "Select"), 3)
                        ]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: state,
                                onClick: ($event: any) => ($setup.requestForm.buyersData.secondBuyer.state = state)
                              }, _toDisplayString(state), 9, _hoisted_63))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.state.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.state.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.getTemplateField('Buyer 2 details', 'Postcode'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _cache[122] || (_cache[122] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.requestForm.buyersData.secondBuyer.postcode) = $event)),
                        type: "text",
                        maxlength: "4",
                        placeholder: "e.g. 2000",
                        class: _normalizeClass({ error: $setup.v$.buyersData.secondBuyer.postcode.$error }),
                        onBlur: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => ($setup.v$.buyersData.secondBuyer.postcode.$touch && $setup.v$.buyersData.secondBuyer.postcode.$touch(...args)))
                      }, null, 34), [
                        [_vModelText, $setup.requestForm.buyersData.secondBuyer.postcode]
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.postcode.$error }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.postcode.$errors[0]?.$message), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ($setup.getTemplateField('Buyer 2 details', 'Upload ID (Drivers license, Passport)'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _cache[123] || (_cache[123] = _createElementVNode("label", { class: "label" }, "ID Type", -1)),
                      _createVNode($setup["DropDown"], null, {
                        control: _withCtx(() => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["input dropdown-input", { error: $setup.v$.buyersData.secondBuyer.documents[0].documentType.$error }])
                          }, _toDisplayString($setup.requestForm.buyersData.secondBuyer.documents[0]?.documentType), 3)
                        ]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", {
                              onClick: _cache[48] || (_cache[48] = ($event: any) => ($setup.setBuyerIdType('secondBuyer', 'Drivers license')))
                            }, "Drivers license"),
                            _createElementVNode("li", {
                              onClick: _cache[49] || (_cache[49] = ($event: any) => ($setup.setBuyerIdType('secondBuyer', 'Passport')))
                            }, "Passport")
                          ])
                        ]),
                        _: 1
                      }),
                      _cache[124] || (_cache[124] = _createElementVNode("div", { class: "error-box" }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Buyer 2 details', 'Upload ID (Drivers license, Passport)'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[125] || (_cache[125] = _createElementVNode("label", { class: "label" }, "Document", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["select-file-wrapper", $setup.getSecondBuyerDocumentClass()])
                      }, [
                        ($setup.showSecondBuyerDocumentName())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, _toDisplayString($setup.requestForm.buyersData.secondBuyer.documents[0].name), 1),
                              _createElementVNode("img", {
                                class: "document-name-close",
                                src: _imports_0,
                                onClick: _cache[50] || (_cache[50] = ($event: any) => ($setup.deleteDocument('secondBuyer')))
                              })
                            ]))
                          : (!$setup.isFileLoading)
                            ? (_openBlock(), _createBlock($setup["InputFile"], {
                                key: 1,
                                onChange: $setup.uploadFile,
                                text: "Upload file",
                                viewClass: "",
                                accept: $setup.acceptedTypes,
                                owner: "secondBuyer"
                              }, null, 8, ["accept"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_71))
                      ], 2),
                      _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.documentPrivacyTip)),
                      _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.imageUploadTips)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyersData.secondBuyer.documents[0].link.$error || $setup.fileInfo.secondBuyer.isError }])
                      }, _toDisplayString($setup.v$.buyersData.secondBuyer.documents[0].name.$errors[0]?.$message || $setup.fileInfo.secondBuyer.errorMessage), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.hasActiveFields('Buyer 2 details'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    class: "button add-buyer",
                    onClick: _cache[51] || (_cache[51] = ($event: any) => ($setup.isSecondBuyer = false))
                  }, _toDisplayString($setup.isPurchasingByCompany ? "Delete Contact Person" : "Delete Buyer") + " 2", 1))
                : _createCommentVNode("", true)
            ], 2),
            ($setup.getTemplateField('default_group', 'Buyer Type (owner occupier or investor)'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _cache[126] || (_cache[126] = _createElementVNode("label", { class: "label" }, "Buyer Type", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", { error: $setup.v$.buyerType.$error }])
                        }, _toDisplayString($setup.requestForm.buyerType), 3)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[52] || (_cache[52] = ($event: any) => ($setup.requestForm.buyerType = 'Owner Occupier'))
                          }, "Owner Occupier"),
                          _createElementVNode("li", {
                            onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.requestForm.buyerType = 'Investor'))
                          }, "Investor")
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.getTemplateField('default_group', 'Agent Referrer (if applicable)'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _cache[127] || (_cache[127] = _createElementVNode("label", { class: "label" }, "Agent Referrer (if applicable)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (($setup.requestForm.agentReferrer) = $event)),
                      type: "text",
                      placeholder: "Agent Referrer"
                    }, null, 512), [
                      [
                        _vModelText,
                        $setup.requestForm.agentReferrer,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.requestAmlInformation && $setup.requestForm.purchaserType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _cache[130] || (_cache[130] = _createElementVNode("h1", { class: "section-title" }, "Identity & Source of Funds", -1)),
                  _cache[131] || (_cache[131] = _createElementVNode("p", { class: "aml-intro" }, "To comply with Australian anti-money laundering laws, we need to collect some additional information to verify your identity and understand the source of your funds.", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.amlBuyers, (buyer) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: buyer.key
                    }, [
                      ($setup.isSecondBuyer)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_77, _toDisplayString(buyer.label), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAmlFieldRows($setup.personAmlFields), (row, rowIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `${buyer.key}-${rowIndex}`
                        }, [
                          _createElementVNode("div", _hoisted_78, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (field) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["input-wr", field.width]),
                                key: `${buyer.key}-${field.key}`
                              }, [
                                _createElementVNode("label", _hoisted_79, [
                                  _createTextVNode(_toDisplayString(field.label), 1),
                                  (field.required)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                (field.type === 'select')
                                  ? (_openBlock(), _createBlock($setup["DropDown"], { key: 0 }, {
                                      control: _withCtx(() => [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["input dropdown-input", { error: $setup.isAmlFieldInvalid(buyer.key, field.key), 'not-selected': !buyer.data[field.key] }])
                                        }, _toDisplayString(buyer.data[field.key] || field.placeholder || "Select"), 3)
                                      ]),
                                      dropdown: _withCtx(() => [
                                        _createElementVNode("ul", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: option,
                                              onClick: ($event: any) => ($setup.setAmlField(buyer.key, field.key, option))
                                            }, _toDisplayString(option), 9, _hoisted_81))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (field.type === 'currency')
                                    ? (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        value: $setup.formatAmlCurrency(buyer.data[field.key]),
                                        type: "text",
                                        inputmode: "numeric",
                                        placeholder: field.placeholder,
                                        class: _normalizeClass({ error: $setup.isAmlFieldInvalid(buyer.key, field.key) }),
                                        onInput: ($event: any) => ($setup.setAmlCurrencyField(buyer.key, field.key, $event)),
                                        onBlur: ($event: any) => ($setup.touchAmlField(buyer.key, field.key))
                                      }, null, 42, _hoisted_82))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 2,
                                        "onUpdate:modelValue": ($event: any) => ((buyer.data[field.key]) = $event),
                                        type: field.type,
                                        min: field.min,
                                        maxlength: field.maxlength,
                                        placeholder: field.placeholder,
                                        class: _normalizeClass({ error: $setup.isAmlFieldInvalid(buyer.key, field.key) }),
                                        onBlur: ($event: any) => ($setup.touchAmlField(buyer.key, field.key))
                                      }, null, 42, _hoisted_83)), [
                                        [_vModelDynamic, buyer.data[field.key]]
                                      ]),
                                (field.hint)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(field.hint), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.isAmlFieldInvalid(buyer.key, field.key) }])
                                }, _toDisplayString($setup.isAmlFieldInvalid(buyer.key, field.key) ? "This field is required" : ""), 3)
                              ], 2))
                            }), 128))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getSelectedOtherFields(buyer.data, row), (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "input-row aml-other-row",
                              key: `${buyer.key}-${field.otherKey}`
                            }, [
                              _createElementVNode("div", _hoisted_85, [
                                _cache[128] || (_cache[128] = _createElementVNode("label", { class: "label" }, "Please specify", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((buyer.data[field.otherKey]) = $event),
                                  type: "text",
                                  placeholder: "Please specify",
                                  class: _normalizeClass({ error: $setup.isAmlFieldInvalid(buyer.key, field.otherKey) }),
                                  onBlur: ($event: any) => ($setup.touchAmlField(buyer.key, field.otherKey))
                                }, null, 42, _hoisted_86), [
                                  [
                                    _vModelText,
                                    buyer.data[field.otherKey],
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.isAmlFieldInvalid(buyer.key, field.otherKey) }])
                                }, _toDisplayString($setup.isAmlFieldInvalid(buyer.key, field.otherKey) ? "This field is required" : ""), 3)
                              ])
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    ], 64))
                  }), 128)),
                  ($setup.isEntityPurchaser)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.getAmlFieldRows($setup.entityAmlFields), (row, rowIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: rowIndex }, [
                          _createElementVNode("div", _hoisted_87, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (field) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["input-wr", field.width]),
                                key: field.key
                              }, [
                                _createElementVNode("label", _hoisted_88, [
                                  _createTextVNode(_toDisplayString(field.label), 1),
                                  (field.required)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, "*"))
                                    : _createCommentVNode("", true)
                                ]),
                                (field.type === 'boolean' || field.type === 'select')
                                  ? (_openBlock(), _createBlock($setup["DropDown"], { key: 0 }, {
                                      control: _withCtx(() => [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["input dropdown-input", { error: $setup.isAmlFieldInvalid('entity', field.key), 'not-selected': $setup.requestForm.amlDetails.entity[field.key] === null || (!$setup.requestForm.amlDetails.entity[field.key] && field.type !== 'boolean') }])
                                        }, _toDisplayString($setup.getAmlFieldValue("entity", field)), 3)
                                      ]),
                                      dropdown: _withCtx(() => [
                                        _createElementVNode("ul", null, [
                                          (field.type === 'boolean')
                                            ? (_openBlock(), _createElementBlock("li", {
                                                key: 0,
                                                onClick: ($event: any) => ($setup.setAmlField('entity', field.key, false))
                                              }, "No", 8, _hoisted_90))
                                            : _createCommentVNode("", true),
                                          (field.type === 'boolean')
                                            ? (_openBlock(), _createElementBlock("li", {
                                                key: 1,
                                                onClick: ($event: any) => ($setup.setAmlField('entity', field.key, true))
                                              }, "Yes", 8, _hoisted_91))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.type === 'select' ? field.options : [], (option) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: option,
                                              onClick: ($event: any) => ($setup.setAmlField('entity', field.key, option))
                                            }, _toDisplayString(option), 9, _hoisted_92))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      "onUpdate:modelValue": ($event: any) => (($setup.requestForm.amlDetails.entity[field.key]) = $event),
                                      type: field.type,
                                      maxlength: field.maxlength,
                                      placeholder: field.placeholder,
                                      class: _normalizeClass({ error: $setup.isAmlFieldInvalid('entity', field.key) }),
                                      onBlur: ($event: any) => ($setup.touchAmlField('entity', field.key))
                                    }, null, 42, _hoisted_93)), [
                                      [_vModelDynamic, $setup.requestForm.amlDetails.entity[field.key]]
                                    ]),
                                (field.hint)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(field.hint), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.isAmlFieldInvalid('entity', field.key) }])
                                }, _toDisplayString($setup.isAmlFieldInvalid("entity", field.key) ? "This field is required" : ""), 3)
                              ], 2))
                            }), 128))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getSelectedOtherFields($setup.requestForm.amlDetails.entity, row), (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "input-row aml-other-row",
                              key: field.otherKey
                            }, [
                              _createElementVNode("div", _hoisted_95, [
                                _cache[129] || (_cache[129] = _createElementVNode("label", { class: "label" }, "Please specify", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => (($setup.requestForm.amlDetails.entity[field.otherKey]) = $event),
                                  type: "text",
                                  placeholder: "Please specify",
                                  class: _normalizeClass({ error: $setup.isAmlFieldInvalid('entity', field.otherKey) }),
                                  onBlur: ($event: any) => ($setup.touchAmlField('entity', field.otherKey))
                                }, null, 42, _hoisted_96), [
                                  [
                                    _vModelText,
                                    $setup.requestForm.amlDetails.entity[field.otherKey],
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.isAmlFieldInvalid('entity', field.otherKey) }])
                                }, _toDisplayString($setup.isAmlFieldInvalid("entity", field.otherKey) ? "This field is required" : ""), 3)
                              ])
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ($setup.hasActiveFields('Solicitor Details'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  _cache[133] || (_cache[133] = _createElementVNode("h1", { class: "section-title" }, "Solicitor Details", -1)),
                  ($setup.estate?.showDontHaveSolicitorEOI)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "solicitor-button-wr",
                        onClick: _cache[55] || (_cache[55] = ($event: any) => ($setup.isDontHaveSolicitorOpen = !$setup.isDontHaveSolicitorOpen))
                      }, [
                        _cache[132] || (_cache[132] = _createElementVNode("h1", { class: "dont-have-solicitor-button" }, "Don't have a solicitor?", -1)),
                        _createElementVNode("img", {
                          class: _normalizeClass(["solicitor-chevron", { 'solicitor-chevron-rotated': $setup.isDontHaveSolicitorOpen }]),
                          src: _imports_1,
                          alt: "chevron-down-icon"
                        }, null, 2)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ($setup.isDontHaveSolicitorOpen && $setup.estate?.showDontHaveSolicitorEOI)
              ? (_openBlock(), _createBlock($setup["EOIDontHaveSolicitor"], {
                  key: 12,
                  estateTitle: $setup.estate?.title,
                  haveOwnSolicitor: $setup.haveOwnSolicitor,
                  "onUpdate:haveOwnSolicitor": $setup.updateHaveOwnSolicitor,
                  "onUpdate:dontHaveOwnSolicitor": $setup.updateDontHaveOwnSolicitor,
                  onClose: _cache[56] || (_cache[56] = ($event: any) => ($setup.isDontHaveSolicitorOpen = !$setup.isDontHaveSolicitorOpen))
                }, null, 8, ["estateTitle", "haveOwnSolicitor"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_98, [
              ($setup.getTemplateField('Solicitor Details', 'Firm Name') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _cache[134] || (_cache[134] = _createElementVNode("label", { class: "label" }, "Firm Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($setup.requestForm.conveyancerDetails.firmName) = $event)),
                      type: "text",
                      placeholder: "Firm Name",
                      disabled: !$setup.haveOwnSolicitor,
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.firmName.$error }),
                      onBlur: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.firmName.$touch && $setup.v$.conveyancerDetails.firmName.$touch(...args)))
                    }, null, 42, _hoisted_100), [
                      [
                        _vModelText,
                        $setup.requestForm.conveyancerDetails.firmName,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.firmName.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.firmName.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Solicitor Details', 'Contact Person') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _cache[135] || (_cache[135] = _createElementVNode("label", { class: "label" }, "Contact Person", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (($setup.requestForm.conveyancerDetails.contactPerson.fullName) = $event)),
                      type: "text",
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "Contact Person",
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.contactPerson.fullName.$error }),
                      onBlur: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.contactPerson.fullName.$touch && $setup.v$.conveyancerDetails.contactPerson.fullName.$touch(...args)))
                    }, null, 42, _hoisted_102), [
                      [
                        _vModelText,
                        $setup.requestForm.conveyancerDetails.contactPerson.fullName,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.contactPerson.fullName.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.contactPerson.fullName.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true)
            ]),
            ($setup.getTemplateField('Solicitor Details', 'Address') || !$setup.haveOwnSolicitor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _cache[136] || (_cache[136] = _createElementVNode("label", { class: "label" }, "Street Address", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (($setup.requestForm.conveyancerDetails.address) = $event)),
                      type: "text",
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "Address",
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.address.$error }),
                      onBlur: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.address.$touch && $setup.v$.conveyancerDetails.address.$touch(...args)))
                    }, null, 42, _hoisted_105), [
                      [
                        _vModelText,
                        $setup.requestForm.conveyancerDetails.address,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.address.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.address.$errors[0]?.$message), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_106, [
              ($setup.getTemplateField('Solicitor Details', 'Suburb') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _cache[137] || (_cache[137] = _createElementVNode("label", { class: "label" }, "Suburb", -1)),
                    _withDirectives(_createElementVNode("input", {
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "Suburb",
                      type: "text",
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.suburb?.$error }),
                      onBlur: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.suburb.$touch && $setup.v$.conveyancerDetails.suburb.$touch(...args))),
                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (($setup.requestForm.conveyancerDetails.suburb) = $event))
                    }, null, 42, _hoisted_108), [
                      [_vModelText, $setup.requestForm.conveyancerDetails.suburb]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.suburb.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.suburb.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Solicitor Details', 'State') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                    _cache[138] || (_cache[138] = _createElementVNode("label", { class: "label" }, "State", -1)),
                    (!$setup.haveOwnSolicitor)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          disabled: !$setup.haveOwnSolicitor,
                          placeholder: "State",
                          type: "text",
                          class: _normalizeClass({ error: $setup.v$.conveyancerDetails.state?.$error }),
                          onBlur: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.state.$touch && $setup.v$.conveyancerDetails.state.$touch(...args))),
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (($setup.requestForm.conveyancerDetails.state) = $event))
                        }, null, 42, _hoisted_110)), [
                          [_vModelText, $setup.requestForm.conveyancerDetails.state]
                        ])
                      : (_openBlock(), _createBlock($setup["DropDown"], { key: 1 }, {
                          control: _withCtx(() => [
                            _createElementVNode("button", {
                              class: _normalizeClass(["input dropdown-input", { error: $setup.v$.conveyancerDetails.state?.$error, 'not-selected': !$setup.requestForm.conveyancerDetails.state }])
                            }, _toDisplayString($setup.requestForm.conveyancerDetails.state || "Select"), 3)
                          ]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: state,
                                  onClick: ($event: any) => ($setup.requestForm.conveyancerDetails.state = state)
                                }, _toDisplayString(state), 9, _hoisted_111))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.state.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.state.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Solicitor Details', 'Postcode') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _cache[139] || (_cache[139] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (($setup.requestForm.conveyancerDetails.postcode) = $event)),
                      type: "text",
                      maxlength: "4",
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "e.g. 2000",
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.postcode.$error }),
                      onBlur: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.postcode.$touch && $setup.v$.conveyancerDetails.postcode.$touch(...args)))
                    }, null, 42, _hoisted_113), [
                      [_vModelText, $setup.requestForm.conveyancerDetails.postcode]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.postcode.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.postcode.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_114, [
              ($setup.getTemplateField('Solicitor Details', 'Email') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                    _cache[140] || (_cache[140] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (($setup.requestForm.conveyancerDetails.contactPerson.email) = $event)),
                      type: "email",
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "Email",
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.contactPerson.email.$error }),
                      onBlur: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => ($setup.v$.conveyancerDetails.contactPerson.email.$touch && $setup.v$.conveyancerDetails.contactPerson.email.$touch(...args)))
                    }, null, 42, _hoisted_116), [
                      [
                        _vModelText,
                        $setup.requestForm.conveyancerDetails.contactPerson.email,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.contactPerson.email.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.contactPerson.email.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true),
              ($setup.getTemplateField('Solicitor Details', 'Phone Number') || !$setup.haveOwnSolicitor)
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    _cache[141] || (_cache[141] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                    _createVNode($setup["Cleave"], {
                      modelValue: $setup.requestForm.conveyancerDetails.contactPerson.phone,
                      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => (($setup.requestForm.conveyancerDetails.contactPerson.phone) = $event)),
                      modelModifiers: { trim: true },
                      disabled: !$setup.haveOwnSolicitor,
                      placeholder: "0412 345 678",
                      options: $setup.phoneNumberOption($setup.requestForm.conveyancerDetails.contactPerson.phone),
                      class: _normalizeClass({ error: $setup.v$.conveyancerDetails.contactPerson.phone.$error }),
                      onBlur: $setup.v$.conveyancerDetails.contactPerson.phone.$touch
                    }, null, 8, ["modelValue", "disabled", "options", "class", "onBlur"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.conveyancerDetails.contactPerson.phone.$error }])
                    }, _toDisplayString($setup.v$.conveyancerDetails.contactPerson.phone.$errors[0]?.$message), 3)
                  ]))
                : _createCommentVNode("", true)
            ]),
            ($setup.hasActiveFields('Contract Conditions'))
              ? (_openBlock(), _createElementBlock("h1", _hoisted_118, "Contract Conditions"))
              : _createCommentVNode("", true),
            ($setup.getTemplateField('Contract Conditions', 'Contract subject to finance?'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _cache[142] || (_cache[142] = _createElementVNode("label", { class: "label" }, "Will you be getting a loan for this purchase?", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", _hoisted_121, _toDisplayString($setup.requestForm.contractConditions.subjectToFinance ? "Yes" : "No"), 1)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[72] || (_cache[72] = ($event: any) => ($setup.subjectToFinance(true)))
                          }, "Yes"),
                          _createElementVNode("li", {
                            onClick: _cache[73] || (_cache[73] = ($event: any) => ($setup.subjectToFinance(false)))
                          }, "No")
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[143] || (_cache[143] = _createElementVNode("div", { class: "error-box" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.requestForm.contractConditions.subjectToFinance && $setup.getTemplateField('Contract Conditions', 'Finance broker details'))
              ? (_openBlock(), _createElementBlock("h1", _hoisted_122, "Finance broker details"))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _cache[144] || (_cache[144] = _createElementVNode("label", { class: "label" }, "Bank (Lending Institution)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (($setup.requestForm.contractConditions.financeBrokerDetails.lendingInstitution) = $event)),
                  type: "text",
                  placeholder: "e.g. CBA Bank"
                }, null, 512), [
                  [
                    _vModelText,
                    $setup.requestForm.contractConditions.financeBrokerDetails.lendingInstitution,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _cache[145] || (_cache[145] = _createElementVNode("label", { class: "label" }, "Finance broker", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (($setup.requestForm.contractConditions.financeBrokerDetails.brokerName) = $event)),
                  type: "text",
                  placeholder: "Finance broker"
                }, null, 512), [
                  [
                    _vModelText,
                    $setup.requestForm.contractConditions.financeBrokerDetails.brokerName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ], 512), [
              [_vShow, $setup.requestForm.contractConditions.subjectToFinance && $setup.getTemplateField('Contract Conditions', 'Finance broker details')]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_126, [
              _createElementVNode("div", _hoisted_127, [
                _cache[146] || (_cache[146] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (($setup.requestForm.contractConditions.financeBrokerDetails.email) = $event)),
                  type: "email",
                  placeholder: "Email",
                  class: _normalizeClass({ error: $setup.v$.contractConditions.financeBrokerDetails.email.$error }),
                  onBlur: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => ($setup.v$.contractConditions.financeBrokerDetails.email.$touch && $setup.v$.contractConditions.financeBrokerDetails.email.$touch(...args)))
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.requestForm.contractConditions.financeBrokerDetails.email,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.contractConditions.financeBrokerDetails.email.$error }])
                }, _toDisplayString($setup.v$.contractConditions.financeBrokerDetails.email.$errors[0]?.$message), 3)
              ]),
              _createElementVNode("div", _hoisted_128, [
                _cache[147] || (_cache[147] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                _createVNode($setup["Cleave"], {
                  modelValue: $setup.requestForm.contractConditions.financeBrokerDetails.phone,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (($setup.requestForm.contractConditions.financeBrokerDetails.phone) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "0412 345 678",
                  options: $setup.phoneNumberOption($setup.requestForm.contractConditions.financeBrokerDetails.phone),
                  class: _normalizeClass({ error: $setup.v$.contractConditions.financeBrokerDetails.phone.$error }),
                  onBlur: $setup.v$.contractConditions.financeBrokerDetails.phone.$touch
                }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.contractConditions.financeBrokerDetails.phone.$error }])
                }, _toDisplayString($setup.v$.contractConditions.financeBrokerDetails.phone.$errors[0]?.$message), 3)
              ])
            ], 512), [
              [_vShow, $setup.requestForm.contractConditions.subjectToFinance && $setup.getTemplateField('Contract Conditions', 'Finance broker details')]
            ]),
            ($setup.requestForm.contractConditions.subjectToFinance && $setup.getTemplateField($setup.EoiTemplateGroups.CONTRACT_CONDITIONS, $setup.EoiTemplateFields.LAND_LOAN_AMOUNT))
              ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _cache[148] || (_cache[148] = _createElementVNode("label", { class: "label" }, "Land loan amount", -1)),
                    _createVNode($setup["Cleave"], {
                      modelValue: $setup.requestForm.contractConditions.landLoanAmount,
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (($setup.requestForm.contractConditions.landLoanAmount) = $event)),
                      modelModifiers: { trim: true },
                      options: $setup.formatLandLoanAmountOptions,
                      placeholder: "100,000",
                      class: _normalizeClass({ error: $setup.v$.contractConditions.landLoanAmount.$error }),
                      onBlur: $setup.v$.contractConditions.landLoanAmount.$touch
                    }, null, 8, ["modelValue", "class", "onBlur"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.contractConditions.landLoanAmount.$error }])
                    }, _toDisplayString($setup.v$.contractConditions.landLoanAmount.$errors[0]?.$message), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.requestForm.contractConditions.subjectToFinance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                  _createElementVNode("div", _hoisted_132, [
                    _cache[149] || (_cache[149] = _createElementVNode("label", { class: "label" }, "Do you have finance pre-approval?", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", {
                          class: _normalizeClass(["input dropdown-input", [{ disabled: !$setup.requestForm.contractConditions.subjectToFinance }]]),
                          disabled: !$setup.requestForm.contractConditions.subjectToFinance
                        }, _toDisplayString($setup.requestForm.contractConditions.financeStatus === "Pre-approved" ? "Yes" : "No"), 11, _hoisted_133)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[80] || (_cache[80] = ($event: any) => ($setup.setFinanceStatus('bank', 'Pending')))
                          }, "No"),
                          _createElementVNode("li", {
                            onClick: _cache[81] || (_cache[81] = ($event: any) => ($setup.setFinanceStatus('bank', 'Pre-approved')))
                          }, "Yes")
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[150] || (_cache[150] = _createElementVNode("div", { class: "error-box" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.requestForm.contractConditions.subjectToFinance && $setup.requestForm.contractConditions.financeStatus === 'Pre-approved')
              ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _cache[151] || (_cache[151] = _createElementVNode("label", { class: "label" }, "Finance Pre-approval Letter", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["select-file-wrapper", $setup.getBankDocumentClass()])
                    }, [
                      ($setup.showBankDocumentName())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, _toDisplayString($setup.requestForm.contractConditions.bankApprovalDocument?.name), 1),
                            _createElementVNode("img", {
                              class: "document-name-close",
                              src: _imports_0,
                              onClick: _cache[82] || (_cache[82] = ($event: any) => ($setup.deleteDocument('bank')))
                            })
                          ]))
                        : (!$setup.isFileLoading)
                          ? (_openBlock(), _createBlock($setup["InputFile"], {
                              key: 1,
                              onChange: $setup.uploadFile,
                              text: "Upload file",
                              viewClass: "",
                              accept: $setup.acceptedTypes,
                              owner: "bank"
                            }, null, 8, ["accept"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_138))
                    ], 2),
                    _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.documentPrivacyTip)),
                    _createElementVNode("span", { class: "tips" }, _toDisplayString($setup.imageUploadTips)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.contractConditions.bankApprovalDocument.link.$error || $setup.fileInfo.bank.isError }])
                    }, _toDisplayString($setup.v$.contractConditions.bankApprovalDocument.name.$errors[0]?.$message || $setup.fileInfo.bank.errorMessage), 3)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.getTemplateField('Contract Conditions', 'Contract subject to FIRB?'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _cache[152] || (_cache[152] = _createElementVNode("label", { class: "label" }, "Contract subject to FIRB? Tick yes if foreign investor", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", _hoisted_141, _toDisplayString($setup.requestForm.contractConditions.FIRB ? "Yes" : "No"), 1)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[83] || (_cache[83] = ($event: any) => ($setup.requestForm.contractConditions.FIRB = true))
                          }, "Yes"),
                          _createElementVNode("li", {
                            onClick: _cache[84] || (_cache[84] = ($event: any) => ($setup.requestForm.contractConditions.FIRB = false))
                          }, "No")
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[153] || (_cache[153] = _createElementVNode("div", { class: "error-box" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.getTemplateField('Contract Conditions', 'Contract subject to any other conditions?'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _cache[154] || (_cache[154] = _createElementVNode("label", { class: "label" }, "Contract subject to any other conditions?", -1)),
                    _createVNode($setup["DropDown"], null, {
                      control: _withCtx(() => [
                        _createElementVNode("button", _hoisted_144, _toDisplayString($setup.subjectToAny ? "Yes" : "No"), 1)
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", {
                            onClick: _cache[85] || (_cache[85] = ($event: any) => ($setup.subjectToAny = true))
                          }, "Yes"),
                          _createElementVNode("li", {
                            onClick: _cache[86] || (_cache[86] = ($event: any) => ($setup.subjectToAny = false))
                          }, "No")
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[155] || (_cache[155] = _createElementVNode("div", { class: "error-box" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["input-row", { hide: !$setup.subjectToAny }])
            }, [
              _createElementVNode("div", _hoisted_145, [
                _cache[156] || (_cache[156] = _createElementVNode("label", { class: "label" }, "Other conditions", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (($setup.requestForm.contractConditions.otherConditions) = $event)),
                  class: _normalizeClass([{ disabled: !$setup.subjectToAny }, { error: $setup.v$.contractConditions.otherConditions.$error }]),
                  placeholder: "Add any other conditions here",
                  disabled: !$setup.subjectToAny
                }, null, 10, _hoisted_146), [
                  [_vModelText, $setup.requestForm.contractConditions.otherConditions]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.contractConditions.otherConditions.$error }])
                }, _toDisplayString($setup.v$.contractConditions.otherConditions.$errors[0]?.$message), 3)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_147, [
              _createVNode($setup["CheckboxInput"], {
                modelValue: $setup.isTermsAccepted,
                "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (($setup.isTermsAccepted) = $event)),
                label: 'I have read and accept the terms, including any non-refundable contract preparation fee terms outlined above.'
              }, null, 8, ["modelValue"])
            ]),
            (!$setup.loading && !$setup.props.isPreview)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 22,
                  class: "button proceed",
                  type: "button",
                  disabled: !$setup.isTermsAccepted,
                  onClick: _cache[89] || (_cache[89] = ($event: any) => ($setup.proceed()))
                }, _toDisplayString($setup.isZeroDeposit ? "Submit" : "Proceed"), 9, _hoisted_148))
              : _createCommentVNode("", true),
            ($setup.loading && !$setup.props.isPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [...(_cache[157] || (_cache[157] = [
                  _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 34)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_150)),
    (!$setup.formLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("div", _hoisted_153, [
              ($setup.isLogged() && $setup.isCustomer)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "save-draft",
                    onClick: _cache[91] || (_cache[91] = ($event: any) => ($setup.draft()))
                  }, "Save draft"))
                : _createCommentVNode("", true)
            ]),
            _createVNode($setup["LotCard"], {
              lot: $setup.lot,
              estate: $setup.estate,
              businessId: $setup.props.businessId
            }, null, 8, ["lot", "estate", "businessId"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}